var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.73293 6.92344C1.81306 6.97374 1.90582 7.00027 2.00043 6.99995H5.50004C5.5809 6.99969 5.66063 7.01905 5.73237 7.05637C5.80411 7.0937 5.86573 7.14787 5.91194 7.21425C5.95815 7.28063 5.98758 7.35723 5.99768 7.43747C6.00779 7.51772 5.99829 7.59923 5.96998 7.67499L5.01009 10.6852C4.99505 10.7398 4.99905 10.798 5.02142 10.8501C5.04379 10.9022 5.08321 10.9452 5.13321 10.9719C5.18321 10.9987 5.24081 11.0076 5.29657 10.9973C5.35232 10.987 5.40292 10.958 5.44004 10.9152L10.3895 5.81488C10.4491 5.7414 10.4866 5.65251 10.4977 5.55854C10.5088 5.46457 10.493 5.36937 10.4522 5.28402C10.4114 5.19867 10.3472 5.12665 10.267 5.07635C10.1869 5.02604 10.0941 4.99951 9.99953 4.99983H6.49992C6.41905 5.00009 6.33933 4.98073 6.26759 4.94341C6.19584 4.90608 6.13422 4.85191 6.08801 4.78553C6.0418 4.71916 6.01238 4.64256 6.00227 4.56231C5.99217 4.48206 6.00167 4.40056 6.02998 4.32479L6.98987 1.31461C7.00491 1.25993 7.00091 1.20176 6.97854 1.14966C6.95616 1.09755 6.91674 1.05459 6.86675 1.02785C6.81675 1.0011 6.75915 0.992147 6.70339 1.00246C6.64764 1.01277 6.59704 1.04174 6.55992 1.0846L1.61047 6.1849C1.55087 6.25839 1.51334 6.34728 1.50223 6.44125C1.49113 6.53522 1.50692 6.63041 1.54775 6.71576C1.58859 6.80112 1.65281 6.87313 1.73293 6.92344Z",
    stroke: "#700AC1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.c84237aa23f226b8c7f4396e77ab0981.svg";
export { ForwardRef as ReactComponent };